export default __webpack_public_path__ + "fonts/banner.2d941a9f056e125066dfd63f1f9481d4.jpg";